var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('div',{attrs:{"id":"content"}},[_c('div',{staticClass:"container"},[_c('h1',[_vm._v(_vm._s(_vm.$t('account.invoices')))]),_c('account-tabs',{attrs:{"active-item":"invoices"}}),_c('invoices')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }